import { useState } from 'react';

import { useAPIV2 } from "../../yoello-lib/modules/API2/useAPIv2";
import APIExtensions from "../../yoello-lib/modules/API2/APIDefs";
import { HTTPMethods } from '../../yoello-lib/modules/API/API';

export interface IEmailSent {
    data: {
        email_verified: boolean;
        email_sent: boolean;
    }
}

const useResendVerification = () => {
    const [ isAlreadyVerified, setIsAlreadyVerified ] = useState(false);
    const [ hasFinishedSending, setHasFinishedSending ] = useState(false);
    const [ isLoading, setIsLoading ] = useState(false);
    const [ error, setError ] = useState<Error | null>();
    
    const { callAPI } = useAPIV2(APIExtensions.sendVerificationEmail, {
        onMountDisabled: true
    });

    const sendVerification = async () => {
        if(isLoading) return;
        setHasFinishedSending(false);
        setIsLoading(true);
        setError(null);
        callAPI(HTTPMethods.POST, {})
            .then((response) => {
                const res = response as IEmailSent;
                if(res.data.email_sent){
                    setHasFinishedSending(true);
                } else {
                    setIsAlreadyVerified(true);
                }
            }).catch(error => {
                setError(error);
            }).finally(() => {
                setIsLoading(false);
            })
    }
    return {
        isLoading,
        hasFinishedSending,
        isAlreadyVerified,
        sendVerification,
        error
    }
}

export default useResendVerification;